import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { useSession } from './useSession';
import type { BalanceData } from '~/types/api';

export function useBalances() {
  const { session } = useSession();

  // Only run authenticated queries when user is fully authenticated
  const isAuthenticated = useMemo(() => {
    return !!session?.user.address;
  }, [session]);

  const {
    data: balances,
    isLoading: isLoadingBalance,
    refetch: refetchBalance,
  } = useQuery({
    queryKey: ['balances', 'getMyBalance'],
    queryFn: () => apiClient.get<BalanceData>('balances.getMyBalance'),
    enabled: isAuthenticated,
  });

  return {
    balance: balances?.balance.balance || 0,
    availableBalance: balances?.balance.availableBalance || 0,
    effectiveYield: balances?.balance.effectiveYield || 0,

    // Loading states
    isLoadingBalance,

    // Actions
    refetchBalance,
  };
}
